import React from 'react';
export function FinalSaleItems() {
  return <section data-id="element-746">
      <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-747">
        Final Sale Items
      </h2>
      <ul className="space-y-2" data-id="element-748">
        <li data-id="element-749">
          • <strong data-id="element-750">Electronics</strong>, <strong data-id="element-751">electronic headgear</strong>,
          and <strong data-id="element-752">electronic chest protectors</strong> are{' '}
          <strong data-id="element-753">non-returnable</strong>.
        </li>
        <li data-id="element-754">
          • <strong data-id="element-755">Engraved</strong> or <strong data-id="element-756">customized items</strong> are{' '}
          <strong data-id="element-757">non-returnable</strong>.
        </li>
        <li data-id="element-758">
          • <strong data-id="element-759">Used items</strong> are <strong data-id="element-760">not eligible</strong> for
          return or exchange.
        </li>
      </ul>
    </section>;
}